/**
 * Language Context
 * 
 * Provides language state throughout the application.
 * Supports both the new 'language' string property and legacy 'isGerm' boolean
 * for backward compatibility during migration.
 * 
 * New pattern (recommended):
 * ```jsx
 * const { language, setLanguage } = useContext(LanguageContext);
 * // or use the useTranslation hook
 * const { t, language } = useTranslation();
 * ```
 * 
 * Legacy pattern (still supported):
 * ```jsx
 * const { isGerm } = useContext(LanguageContext);
 * ```
 */

import React, { createContext } from 'react';
import { EN } from '../Languages/EN';

const LanguageContext = createContext({
    // New language system - string-based language code
    language: 'de',
    setLanguage: () => {},
    
    // Legacy support - boolean for German/English toggle
    isGerm: true,
    setIsGerm: () => {},
    
    // Current language strings object - use strings.key instead of isGerm ? DE.key : EN.key
    strings: EN,
    
    // Translation helper function - use t('key') for translations
    t: (key) => EN[key] || key,
});

export const LanguageProvider = LanguageContext.Provider;
export default LanguageContext;
